/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2026 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2026 - Finnish Meteorological Institute (FMI)
 * Copyright 2026 - The Norwegian Meteorological Institute (MET Norway)
 * */

import { Link } from '@mui/material';
import React from 'react';

const URL_REGEX = /(https?:\/\/[^\s<>"')]+)/g;

// Splits text on URLs and turns them into links
export const linkifyText = (
  text: string,
  keyPrefix = 'linkified',
): React.ReactNode[] =>
  text
    .split(URL_REGEX)
    .filter((url) => url !== '')
    .map((part, index) =>
      /^https?:\/\//.test(part) ? (
        <Link
          href={part}
          // eslint-disable-next-line react/no-array-index-key
          key={`${keyPrefix}-${index}`}
          rel="noopener noreferrer"
          target="_blank"
        >
          {part}
        </Link>
      ) : (
        // eslint-disable-next-line react/no-array-index-key
        <React.Fragment key={`${keyPrefix}-${index}`}>{part}</React.Fragment>
      ),
    );
